export enum ClientId {
    SIEMENS = 1,
    HEALTHCARE = 2,
    HEALTHCARE_CH = 3,
    FLENDER = 4,
    ENERGY = 5
}
